import fetch from 'dva/fetch';
import fetchJsonp from 'fetch-jsonp';
import { Toast } from "antd-mobile";
import { stringify } from 'qs';
import { setTimeout, clearTimeout } from 'timers';

const codeMessage = {
  200: '服务器成功返回请求的数据',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据,的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
};

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
  options.headers = {
   ...options.headers,
   sourceCode: window.sourceCode,
  }
  const defaultOptions = {
    credentials: 'include',
    timeout: 15000,
  };
  let timer;
  function checkStatus(response) {
    if ((response.status >= 200 && response.status < 300) || response.ok) {
      return response;
    }
    clearTimeout(timer);
    const errortext = codeMessage[response.status] || response.statusText;
    
    Toast.fail("网络错误", 2);
    
    console.log(errortext);
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
  }
  let newUrl = `${url}?_t=${new Date().getTime()}`;
  // 旧版get方法
  if (url.indexOf('?') !== -1) {
    newUrl = `${url}&_t=${new Date().getTime()}`;
  }
  let newOptions = { ...defaultOptions, ...options };
  newOptions.method = newOptions.method ? newOptions.method.toUpperCase() : 'GET';
  if (newOptions.method === 'GET' && newOptions.body) {
    newUrl = `${url}?_t=${new Date().getTime()}&${stringify(newOptions.body)}`;
    delete newOptions.body;
  }
  if (newOptions.method === 'POST' || newOptions.method === 'PUT') {
    newUrl = url.indexOf('?')>-1?`${url}&_t=${new Date().getTime()}`:`${url}?_t=${new Date().getTime()}`;
    if (newOptions.type === 'getShortLinks') {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Token: newOptions.TOKEN,
        ...newOptions.headers,
      };
    } else {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        ...newOptions.headers,
      };
    }
    if (newOptions.headers['Content-Type'] === 'application/json') {
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      newOptions.body = stringify(newOptions.body);
    }
  }
  if (options.type === 'user') {
    newUrl = url;
    newOptions = options;
  }
  let done = fetch;
  if (newOptions.dataType === 'jsonp') {
    done = fetchJsonp;
  }
  timer = setTimeout(() => {
    console.log('网络超时');
    Toast.fail("网络超时", 2);
  }, defaultOptions.timeout);
  return done(newUrl, newOptions)
    .then(checkStatus)
    .then((response) => {
      clearTimeout(timer);
      if (newOptions.method === 'DELETE' || response.status === 204) {
        return response.text();
      }
      return response.json();
    }).then((data) => {
      if (data.code === '999'||data.code==='401') {
        Toast.fail(data.msg, 2);  
      }
      return Promise.resolve(data);
    })
    .catch(() => {
      clearTimeout(timer);
      
      if (options.catch) {
        options.catch();
      } else {
        Toast.fail('网络连接异常',2);
        
      }
      return Promise.reject('网络连接异常');
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js